(function () {
    "use strict";

    angular.module("app").controller("SearchFinishedAssistanceInListsController", SearchFinishedAssistanceInListsController);

    SearchFinishedAssistanceInListsController.$inject = ["controllerDecorator", "infiniteScrollDataSourceFactory", "assistanceInList",];
    function SearchFinishedAssistanceInListsController(controllerDecorator, infiniteScrollDataSourceFactory, assistanceInList) {
        const vm = this;
        controllerDecorator.Decorate(vm, []);

        Object.defineProperty(vm, "Filter", { get: () => vm.DataSource.GetFilter() });
        Object.defineProperty(vm, "PageAndSort", { get: () => vm.DataSource.GetPageAndSort() });
        Object.defineProperty(vm, "Items", { get: () => vm.DataSource.Items() });

        activate();

        function activate() {
            vm.DataSource = infiniteScrollDataSourceFactory.Create(assistanceInList.SearchFinished, (v) => vm.isLoadingRequests = v);

            if (vm.PageAndSort.SortBy.length > 0) {
                vm.sortType = vm.PageAndSort.SortBy[0].Name;
                vm.sortReverse = vm.PageAndSort.SortBy[0].IsReverse;
            }
            else {
                vm.sortType = "ListNumber";
                vm.sortReverse = true;
            }

            vm.SetLoadingState(false);
        }
    }
})();
